import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_LIST } from 'actions/apiActionConstants'
import getMerchandiseList from 'api/merchandise/getMerchandiseList'
import getObjectKey from 'lib/object/getObjectKey'

function fetchMerchandiseSearchAdverts(filters: App.MerchandiseFilters): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = getObjectKey(filters)
    if (state.merchandise.merchandiseLists[key] ||
      state.merchandise.fetchingMerchandiseLists[key] ||
      state.merchandise.merchandiseListErrors[key]
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_LIST,
      request: () => getMerchandiseList(filters),
      key,
    })
  }
}

export default fetchMerchandiseSearchAdverts
